import { createFormHook, createFormHookContexts } from '@tanstack/react-form';
import { TextField } from './TextField';
import { TextAreaField } from './TextAreaField';
import { DateField } from './DateField';
import { NumberField } from './NumberField';
import { SelectField } from './SelectField';

export const { fieldContext, formContext, useFieldContext } =
  createFormHookContexts();

export const { useAppForm, withForm, withFieldGroup } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {
    TextField,
    TextAreaField,
    DateField,
    NumberField,
    SelectField,
  },
  formComponents: {},
});
